import Icon from '../Icon.vue'

Icon.register({
  'enlarge_screen': {
    width: 30,
    height: 30,
    paths: [
      {
        d: 'M29 4v22a3 3 0 01-3 3H4a3 3 0 01-3-3V4a3 3 0 013-3h22a3 3 0 013 3z',
        fill: 'white'
      },
      {
        d: 'M6.335 15.01l.903.012a.713.713 0 01.698.714l-.054 4.783 4.117-4.118a.689.689 0 01.976.012l.66.66c.273.273.279.708.012.975l-4.118 4.118 4.782-.055a.707.707 0 01.714.699l.012.902a.666.666 0 01-.68.68l-7.903-.099a.709.709 0 01-.698-.698l-.101-7.904a.666.666 0 01.68-.68zm9.356-9.332l7.902.1a.709.709 0 01.698.698l.102 7.904a.666.666 0 01-.68.68l-.903-.011a.712.712 0 01-.698-.715l.054-4.782-4.118 4.118a.689.689 0 01-.976-.012l-.659-.66a.689.689 0 01-.012-.975l4.118-4.118-4.782.054a.707.707 0 01-.715-.698l-.011-.903a.666.666 0 01.68-.68z'
      }
    ]
  }
})
